import {createSlice} from "@reduxjs/toolkit";
import {FAILED, LOADING, SUCCESS} from "../../common/statuses";
import {initialState, RECEIPT} from "./initState";
import {confirmPayment, deletePayment, getPayments, sendReceipt} from "./receiptService";
import {errorConverter, errorConverterFields} from "../../common/formater";

const receiptReducer = createSlice({
    name: RECEIPT,
    initialState,
    reducers: {
        clearReceiptState: () => {
            return  {...initialState}
        }
    },
    extraReducers(builder) {
        builder
            .addCase(sendReceipt.pending, ({loadReceipt}) => {
                loadReceipt.status = LOADING
            })
            .addCase(sendReceipt.fulfilled, ({loadReceipt}) => {
                loadReceipt.status = SUCCESS
                loadReceipt.message = "Квитанция отправлена успешно";
            })
            .addCase(sendReceipt.rejected, ({loadReceipt}, action) => {
                loadReceipt.status = FAILED
                loadReceipt.message = errorConverter(action)
            })

            .addCase(getPayments.pending, ({getPayments}) => {
                getPayments.status = LOADING
            })
            .addCase(getPayments.fulfilled, ({getPayments}, action) => {
                getPayments.status = SUCCESS
                getPayments.data = action.payload
            })
            .addCase(getPayments.rejected, ({getPayments}) => {
                getPayments.status = FAILED
            })

            .addCase(deletePayment.pending, ({deletePayment}) => {
                deletePayment.status = LOADING
            })
            .addCase(deletePayment.fulfilled, ({deletePayment}) => {
                deletePayment.status = SUCCESS
                deletePayment.message = "Квитанция удалена успешно";
            })
            .addCase(deletePayment.rejected, ({deletePayment}, action) => {
                deletePayment.status = FAILED
                deletePayment.message = errorConverter(action)
            })

            .addCase(confirmPayment.pending, ({confirmPayment}) => {
                confirmPayment.status = LOADING
            })
            .addCase(confirmPayment.fulfilled, ({confirmPayment}, action) => {
                confirmPayment.status = SUCCESS
                confirmPayment.message = `Квитанция №${action.payload.id} подтверждена`;
            })
            .addCase(confirmPayment.rejected, ({confirmPayment}, action) => {
                confirmPayment.status = FAILED
                confirmPayment.message = errorConverterFields(action)
            })
    }
})

export const {clearReceiptState} = receiptReducer.actions;

export default receiptReducer.reducer;